<template>
  <div class="user_contact">
    <div class="photo">
      <div class="photo_box">
        <span v-if="!photo">{{ localStorage.translations.pages.common.text['net-foto'] }}</span>
        <img
          v-else-if="checkbox.photo && !checkbox.photo.value"
          :src="apiDomain + '/min/' + photo"
          alt=""
        />
      </div>
    </div>
    <div class="data">
      <div class="data_top">
        <div class="data_top_left">
          <h2 v-if="checkbox.name && !checkbox.name.value">
            {{ first_name + ' ' + last_name }}
          </h2>
          <div>
            <div class="dob" v-if="dateBirthdayFormatted && checkbox.dob && !checkbox.dob.value">
              <span>{{ dateBirthdayFormatted + ' ' + currentAge }}</span>
            </div>
            <div v-if="checkbox.email && !checkbox.email.value" class="email mb-4">
              {{ email }}
            </div>
          </div>
          <div v-if="checkbox.phone && !checkbox.phone.value" class="data_top_right">
            <div class="phone" v-for="(i, index) in phone" :key="index">
              {{ i }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicDataPdf',
  props: {
    userData: {
      type: Object,
      default: null,
    },
    editing: Boolean,
    checkbox: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {},
  data: () => ({
    valid: true,
    last_name: null,
    first_name: null,
    email: null,
    menu: false,
    phone: [],
    items: [],
    file: '',
    currentAge: null,
    photo: null,
    dateBirthday: null,
    dateBirthdayFormatted: null,
    imgDataUrl: null,
  }),
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  watch: {
    userData() {
      if (this.userData) {
        this.last_name = this.userData.last_name
        this.first_name = this.userData.first_name
        this.email = this.userData.email
        this.phone = this.userData.phone
        this.photo = this.userData.photo
        this.dateBirthday = this.userData.dob
      }
    },
    phone() {
      for (let i in this.phone) {
        if (this.phone[0] !== this.phone[i]) {
          if (this.phone[i] === null || '') {
            this.phone.splice(i, 1)
          }
        }
      }
    },
    photo() {
      //this.getImg()
    },
    imgDataUrl() {
      this.$emit('onImgReady', this.imgDataUrl !== null)
    },
    dateBirthday(val) {
      this.dateBirthdayFormatted = this.formatDate(this.dateBirthday)
      this.getCurrentAge(this.dateBirthday)
    },
  },
  mounted() {
    if (this.userData) {
      this.last_name = this.userData.last_name
      this.first_name = this.userData.first_name
      this.email = this.userData.email
      this.phone = this.userData.phone
      this.photo = this.userData.photo
      this.dateBirthday = this.userData.dob
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getCurrentAge(date) {
      let currentAge = ((new Date().getTime() - new Date(date)) / (24 * 3600 * 365.25 * 1000)) | 0
      this.ageToStr(currentAge)
    },
    ageToStr(age) {
      let txt
      let count = age % 100
      if (count >= 5 && count <= 20) {
        txt = this.localStorage.translations.pages.common.measure.years_old
      } else {
        count = count % 10
        if (count == 1) {
          txt = this.localStorage.translations.pages.common.measure.year
        } else if (count >= 2 && count <= 4) {
          txt = this.localStorage.translations.pages.common.measure.of_the_year
        } else {
          txt = this.localStorage.translations.pages.common.measure.years_old
        }
      }
      return (this.currentAge = age + ' ' + txt)
    },
    getImg() {
      let url = this.apiDomain + '/min/' + this.photo
      this.$axios
        .get(url, {responseType: 'arraybuffer'})
        .then(
          (response) =>
            (this.imgDataUrl = `data:${response.headers['content-type']};base64,${btoa(
              String.fromCharCode(...new Uint8Array(response.data)),
            )}`),
        )
    },
  },
}
</script>

<style lang="scss" scoped>
.user_contact {
  display: grid;
  grid-template-columns: 240px auto;
  grid-column-gap: 30px;
  font-weight: normal;
  font-size: 16px;
  color: #2c2c2c;

  .photo {
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 240px;
    width: 240px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
      overflow: hidden;
    }

    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      @media screen and (max-width: 1800px) {
        margin-left: 3px;
      }
    }

    &_box {
      background: #277faf;
      width: 100%;
      height: 100%;
      display: grid;
      align-items: center;
      transition: 0.3s;

      &:not(.add) {
        user-select: none;
      }
    }
  }

  .data {
    display: grid;

    &_top {
      display: grid;
      grid-template-columns: auto max-content;

      &_left {
        h2 {
          font-weight: bold;
          font-size: 22px;
          margin-bottom: 20px;
        }

        .dob {
          margin-bottom: 16px;
        }
      }

      &_right {
        display: flex;
        flex-direction: column;
      }
    }

    &_bot {
      align-self: end;
      display: grid;
      grid-template-columns: max-content auto;
      justify-content: start;
      grid-gap: 20px;

      .name {
        color: #92909c;
      }
    }
  }
}
</style>
